import { render } from "./OperatoriView.vue?vue&type=template&id=bf8f02b0"
import script from "./OperatoriView.vue?vue&type=script&lang=js"
export * from "./OperatoriView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__